/* eslint-disable no-undef */
let CryptoJS      = require('crypto-js');
/* eslint-enable no-undef */
let keySize       = 256;
let ivSize        = 128;
let iterations    = 1000;
/* eslint-disable no-undef */
let password      = CryptoJS.SHA512(process.env.REACT_APP_CRYPTINFO).toString(); 
const canEncrypt  = process.env.REACT_APP_ALLOW_ENCRYPT === 'true'?true:false;
/* eslint-enable no-undef */

//Encrypting data
export async function encryptData(encryptInfo,callback){
	if(!canEncrypt){
		return callback(encryptInfo);
	}else{
		let encSalt = CryptoJS.lib.WordArray.random(ivSize/8);
		let encIv   = CryptoJS.lib.WordArray.random(ivSize/8);
		let encKey  = CryptoJS.PBKDF2(password, encSalt, {
			keySize    : keySize/32,
			iterations : iterations
		});

		encryptInfo  = JSON.stringify(encryptInfo);
		let encrypted = CryptoJS.AES.encrypt(encryptInfo, encKey, { 
			iv      : encIv, 
			padding : CryptoJS.pad.Pkcs7,
			mode    : CryptoJS.mode.CBC,
			hasher  : CryptoJS.algo.SHA512
		}).toString();
		let transitmessage = encSalt.toString()+encIv.toString()+encrypted.toString();
		return callback(transitmessage);
	}
}

// Decrypt data
export async function decryptData(decryptInfo,callback){
	if(!canEncrypt){
		return callback(decryptInfo);
	}else{
		let decSalt     = CryptoJS.enc.Hex.parse(decryptInfo.substr(0, 32));
		let decIv       = CryptoJS.enc.Hex.parse(decryptInfo.substr(32, 32));
		let encrypted  = decryptInfo.substring(64);
		let decKey      = CryptoJS.PBKDF2(password, decSalt, {
			keySize: keySize/32,
			iterations: iterations
		});

		let decrypted = CryptoJS.AES.decrypt(encrypted, decKey, { 
			iv      : decIv, 
			padding : CryptoJS.pad.Pkcs7,
			mode    : CryptoJS.mode.CBC,
			hasher  : CryptoJS.algo.SHA512
		}).toString(CryptoJS.enc.Utf8);
		try{
			decrypted = await JSON.parse(decrypted); // REMOVE slash
			decrypted = await JSON.parse(decrypted); // CONVERT TO OBJECT
			return callback(decrypted);
		}catch(e){
			return callback(decrypted);
		}
	}
}
